import { render } from "./CircleXMarkIcon.vue?vue&type=template&id=170832cf&scoped=true"
const script = {}

import "./CircleXMarkIcon.vue?vue&type=style&index=0&id=170832cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170832cf"]])

export default __exports__